// A length in minutes, read back as words: what a waitlist card and the
// drawer's notice say. The length a patient waits for is the service's (the
// server never takes one from a patient), so nothing here parses a catalogue.

/** "90" -> "1 h 30 min", for a value that is a whole number of minutes. */
export function formatMinutes(value) {
  if (!Number.isInteger(value) || value <= 0) return "";
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} h`;
  return `${hours} h ${minutes} min`;
}
